import { useT } from '../lib/i18n';

/**
 * Who reads a note: the coach alone, or the player too.
 *
 * On every note field, so the coach never has to remember which box is
 * private. Writing "losing confidence" in the one the player reads is
 * the mistake this exists to prevent.
 */
export function Vis({ who }: { who: 'me' | 'player' }) {
  const t = useT();
  return <span className={`vis vis--${who}`}>{t(who === 'me' ? 'vis.me' : 'vis.player')}</span>;
}

/** A field's label with its Vis on the right. */
/** `extra`: a small tag kept on the same line as the text (e.g. «AI»). */
export function VisLabel({ text, who, extra }: { text: string; who: 'me' | 'player'; extra?: import('react').ReactNode }) {
  return <span className="vislabel"><span className="vislabel__text">{text}{extra}</span><Vis who={who} /></span>;
}
